// Below md the studio is a phone or a small tablet, where keeping copies of
// models is a bad trade: tens of megabytes per model against a fraction of the
// storage quota a desktop gets, on a device whose tab is killed for overrunning
// memory. Both the variations prefetch and the load-path copy defer to this, so
// there is one definition of "big enough to cache on" rather than two that drift.
//
// `undefined` is what useBreakpoint reports with no window (server-side), and is
// treated as not-desktop so nothing is cached before the viewport is known.
const CACHEABLE_FROM = new Set(['md', 'lg', 'xl', 'xxl'])

/**
 * @param {string|undefined} breakpoint - a useBreakpoint / getBreakPoint value
 * @returns {boolean}
 */
export const isDesktopBreakpoint = breakpoint => CACHEABLE_FROM.has(breakpoint)
